// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `input[type="file"] {
    display: none;
}

.custom-file-upload {
    padding: 0;
    min-width: 0;
    width: 40px;
    height: 40px;
    flex-shrink: 0;
    line-height: 40px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    text-align: center;
    align-content: center;
    flex-direction: column;
}

.file-upload {
    margin-top: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/app/settings/navigation/overview/navigation.overview.settings.css"],"names":[],"mappings":"AAAA;IACI,aAAa;AACjB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;AACnB","sourcesContent":["input[type=\"file\"] {\n    display: none;\n}\n\n.custom-file-upload {\n    padding: 0;\n    min-width: 0;\n    width: 40px;\n    height: 40px;\n    flex-shrink: 0;\n    line-height: 40px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    text-align: center;\n    align-content: center;\n    flex-direction: column;\n}\n\n.file-upload {\n    margin-top: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
